var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import cuid from "cuid";
import { v4 as uuid } from "uuid";
export default function refreshToken(refreshToken, appName, env = "prod") {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const headers = {
            "Content-Type": "application/json",
            "X-App-Name": appName,
            "X-App-Version": "1.0",
            "X-Request-Id": cuid(),
            "X-Correlation-Id": uuid(),
        };
        const baseUrl = env === "dev"
            ? "https://login-api-dev.agyo.io"
            : env === "test"
                ? "https://login-api-test.agyo.io"
                : "https://login-api.agyo.io";
        try {
            const response = yield axios.request({
                url: `${baseUrl}/login/tsid/v3/refresh`,
                method: "POST",
                data: JSON.stringify({ refreshToken }),
                headers,
            });
            return response.data;
        }
        catch (e) {
            if (axios.isAxiosError(e)) {
                throw { status: (_a = e.response) === null || _a === void 0 ? void 0 : _a.status, data: (_b = e.response) === null || _b === void 0 ? void 0 : _b.data };
            }
            throw e;
        }
    });
}
